import React, { useState, useEffect } from 'react';

const GifComponent = () => {
  const images = ['images/ycm.png', 'images/cmy.png', 'images/myc.png','images/im11.png','images/im00.png','images/impng.png','images/impng.png'];
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    }, 1000 / 5); // 5 FPS, if you want 30 FPS, change to 1000 / 30

    return () => clearInterval(intervalId);
  }, [images.length]);

  return (
    <img id="gif-image" src={images[currentImage]} alt="GIF Image" />
  );
};

export default GifComponent;